import { z } from 'zod';
import { UUIDSchema } from './common';
import { EnergySummarySchema } from './energy';
export const PortfolioEnergySummarySchema = z.object({
    portfolio_uuid: UUIDSchema,
    energy_summary: EnergySummarySchema,
});
export const MultiPortfolioEnergySummarySchema = z.object({
    portfolios: PortfolioEnergySummarySchema.array(),
    energy_summary: EnergySummarySchema,
});
